// Modules
import { createAction, props } from '@ngrx/store';

//------------- Pending (mustChangePassword: true detected in login response) ----------------
export const forcedPasswordChangePending = createAction(
  '[Forced Password Change] Pending',
  props<{ payload: { challengeId: string } }>()
);

//------------- Requested (form submit) ----------------
export const forcedPasswordChangeRequested = createAction(
  '[Forced Password Change] Requested',
  props<{ payload: { challengeId: string; newPassword: string } }>()
);

//------------- Success (full user object returned by backend) ----------------
export const forcedPasswordChangeSuccess = createAction(
  '[Forced Password Change] Success',
  props<{ payload: { user: any } }>()
);

//------------- Failed ----------------
export const forcedPasswordChangeFailed = createAction(
  '[Forced Password Change] Failed',
  props<{
    payload: {
      // Server validation message to show under the password field (no toast)
      fieldError?: string;
      // Generic/unexpected error to show as a toast
      toastMessage?: string;
      // Session/token issue: redirect back to login
      sessionExpired?: boolean;
    };
  }>()
);

//------------- Cleared (on component destroy or flow completion) ----------------
export const forcedPasswordChangeCleared = createAction(
  '[Forced Password Change] Cleared'
);
